export const MessageTypes = {
  AGENT: 'AGENT',
  CUSTOMER: 'CUSTOMER'
};

export const MAX_ORDERS = 5;
export const COOKIE_NAME_AT = 'at';
export const COOKIE_NAME_TICKET = 'ticket';
export const HEADER_NAME_USER_AGENT = 'User-Agent';
export const X_CHEWY_AUTH_ACCESS_TOKEN = 'X-Chewy-Auth-Access-Token';
export const X_CHEWY_AUTH_ID_TOKEN = 'X-Chewy-Auth-Id-Token';
